import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Grade } from "app/models/grade";

@Injectable()
export class GradeService {
  private url = `/api/grade`;

  constructor(private http: HttpClient) {}

  public find(): Observable<[Grade]> {
    const params = new HttpParams()
      .set("size", "page")
      .set("size", "50")
      .set("sortName", "libelle")
      .set("sortType", "ASC");
    return this.http.get<[Grade]>(this.url, { params: params });
  }

  /**
   * create a  new Grade
   * @param Grade
   */
  create(grade: Grade) {
    return this.http.post(this.url, grade).map(data => {
      console.log(data);
    });
  }
  /**
   * delete a new grade
   * @param grade
   */
  delete(grade: Grade) {
    return this.http.delete(`${this.url}/${grade.id}`).map(data => {
      console.log(data);
    });
  }
  /**
   * update a grade
   * @param grade
   */
  update(grade: Grade) {
    return this.http.put(`${this.url}/${grade.id}`, grade).map(data => {
      console.log(data);
    });
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/grade.service.ts